import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import clsx from "clsx";
import {Parallax} from "react-scroll-parallax";

import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import {Button, Collapse} from "../../components/common";
import {BUTTON_TYPES, ROUTES} from "../../types";
import {AppointmentModal} from "../../components/modal";
import {CountReward} from "../../components/ui";

const FAQ_DATA = [
  {
    title: 'Как зарегистрироваться?',
    description: 'Пройдите регистрацию по адресу https://beetobee.org/applications. Заполните поля и приложите форму присоединения ( шаблон скачайте и заполните, образцы для ИП, Самозанятого и ООО прилагаются. После этого  на почту придет письмо с активацией учетной записи, перейдите по ссылке. В течение 30 минут учетная запись будет активирована и вы сможете отправлять заявки. Если письмо не приходит или запись не активирована, обратитесь к своему менеджеру. '
  },
  {
    title: 'Как заключить договор?',
    description: 'Для регистрации необходимо зарегистрироваться на площадке https://beetobee.org/sign-in и прислать форму присоединения по установленному образцу.'
  },
  {
    title: 'Как и когда производятся выплаты?',
    description: 'Выплаты проводятся до 25 числа следующего за отчетным периодом.  (например: за январь до 25 февраля)'
  },
  {
    title: 'Сколько заявок можно отправлять?',
    description: 'Можно отправлять неограниченное количество заявок, ВАЖНО, чтобы клиент при необходимости подтвердил, что с его согласия были отправлены заявки. В случае отправления заявок без согласия клиента и жалоб клиента на звонки банка, агент будет отключен от площадки и договор будет расторгнут. '
  },
  {
    title: 'Как быть с дублями?',
    description: 'В ряде банков возможно отбить дубли, для уточнения как, обратитесь к своему менеджеру.'
  },
  {
    title: 'Когда и кто звонить клиенту?',
    description: 'После отправления заявки она сразу попадает в банк и менеджер связывается с ней в порядке очереди. Как правило это происходит в течение часа. (Если клиенту не позвонили в этот промежуток времени, необходимо связаться со своим менеджером в В2В и попросить банк связаться с клиентом. Менеджер В2В обращается к ответственному менеджеру в банке (сам или через руководителя) и уточняет причину отсутствия звонка.'
  },
  {
    title: 'Как быстро открывается счет?',
    description: '1. Сначала заявка попадает в банк и менеджер или КЦ банка связывается для запроса документов и обработки заявки. (в течение часа)\n' +
      '2. Сотрудник банка обрабатывает полученные документы и проходит проверку службы безопасности ( в течение суток)\n' +
      '3. Договариваются об открытии счета, либо приглашают в банк, либо на встречу с курьером, в зависимости от банка и региона.  Иногда счета открывают за 1 день. Чаще за 5-7 дней, все зависит от оперативности клиента.\n'
  },
  {
    title: 'Какие банки у вас есть и какие выплаты?',
    description: 'С перечнем банков и суммой вознаграждения можете ознакомиться на нашем сайте https://beetobee.org//product'
  },
  {
    title: 'Как часто обновляются статусы?',
    description: 'По ряду банков статусы обновляются каждые 30 минут, по некоторым банкам статусы обновляются раз в неделю. Для утончения актуального статуса обратитесь к своему персональному менеджеру.'
  },
  {
    title: 'Кто может заключить договор?',
    description: 'Договор могут заключить только ИП, ООО или самозанятый. С физ. лицами пока не работаем.'
  },
  {
    title: 'Какие заявки можно отправлять?',
    description: 'Перед тем как отправить заявку вам необходимо получить от клиента согласие на отправление его перс данных в конкретный банк(и). Если вы работаете как коллцентр у вас обязательно должна быть запись диалога с конкретным клиентом, где он соглашается на отправление заявки в банк партнер и звонок представителя банка для консультации по открытию счета.'
  },
]

function Landing() {
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  }

  const handleCloseModal = () => {
    setIsOpenModal(false);
  }

  return (
    <>
      <AppointmentModal open={isOpenModal} onClose={handleCloseModal} />
      <div className="relative w-full min-h-screen py-12 px-4 flex flex-col items-center bg-siteBg bg-no-repeat bg-center bg-cover">
        <div className="max-w-[1320px] w-full mx-auto">
          <Navbar />
        </div>

        <div className="mt-[122px] max-w-[1320px]">
          <p
            className="font-bold text-[140px] leading-[145px] text-black text-center lg:text-[60px] lg:leading-[66px] sm:text-[45px] sm:leading-[56px]"
          >
            Зарабатывай
            на своих клиентах
            больше
          </p>

          <p
            className="text-2xl mt-10 mx-auto text-black max-w-[820px] font-medium text-center lg:text-xl sm:mt-5"
          >Рекомендуйте банковские продукты бизнесу и получите дополнительный доход до 6 000 рублей за клиента</p>
        </div>
      </div>

      <Parallax speed={-10}>
        <div className="w-full pt-[150px] pb-[300px] mx-auto text-center relative bg-parallaxMainBG bg-center bg-no-repeat lg:bg-left lg:pt-15">
          <div className="max-w-[820px] mx-auto">
            <h3 className="text-[40px] leading-[28px] font-bold text-darkGray">Большая база клиентов? </h3>
            <p className="mt-3 text-black/75 text-sm leading-[16px]">Зарабатывайте на рекомендациях финансовых продуктов своим клиентам.</p>
            <p className="text-darkGray text-[20px] leading-[22px] mt-6">BeeToBee – платформа для бухгалтеров, юристов, веб мастеров и других агентов, с помощью которой можно получать дополнительный заработок на существующей клиентской базе</p>

            <Button
              title={'Стать агентом BeeToBee'}
              onClick={() => navigate(ROUTES.SIGN_UP)}
              type={BUTTON_TYPES.SECONDARY}
              className="py-3 px-16 mx-auto mt-10 text-base leading-[18px]"
            />
          </div>
        </div>
      </Parallax>

      <div className="flex flex-wrap justify-center items-center pb-[180px] gap-3 lg:pb-8">
        <div className="w-[435px] pt-8 bg-black h-[496px] relative sm:h-[350px]">
          <p className="text-white font-bold text-[24px] leading-[29px] text-center">Большие комиссии</p>
          <p className="text-white text-sm leading-[17px] mt-2 text-center">Мы — крупный партнёр ведущих банков страны</p>
          <Button
            title={'Посмотреть вознаграждения'}
            onClick={() => navigate(ROUTES.PRODUCT)}
            type={BUTTON_TYPES.SECONDARY}
            className="absolute z-10 bottom-[30px] w-[266px] translate-x-[-50%] left-[50%]"
          />
          <img src="/cards/1.png" alt="card" className="absolute bottom-0 left-0 right-0"/>
        </div>

        <div className="w-[435px] pt-8 bg-black h-[496px] relative overflow-y-hidden sm:h-[350px]">
          <p className="text-white font-bold text-[24px] leading-[29px] text-center">Быстрая тех.поддержка</p>
          <p className="text-white text-sm leading-[17px] mt-2 text-center">
            Персональный менеджер отвечает за 15 минут
          </p>
          <Button
            title={'Написать менеджеру'}
            onClick={handleOpenModal}
            className="absolute z-10 bottom-[30px] w-[266px] translate-x-[-50%] left-[50%]"
          />
          <img src="/cards/2.png" alt="card" className="absolute bottom-[-100px] left-0 right-0"/>
        </div>

        <div className="w-[435px] pt-8 bg-black h-[496px] relative overflow-y-hidden sm:h-[350px]">
          <p className="text-white font-bold text-[24px] leading-[29px] text-center">Удобный ЛК</p>
          <p className="text-white text-sm leading-[17px] mt-2 text-center">
            Все заявки подаются онлайн в один клик
          </p>
          <Button
            title={'Стать агентом'}
            onClick={() => navigate(ROUTES.SIGN_UP)}
            type={BUTTON_TYPES.SECONDARY}
            className="absolute z-10 bottom-[30px] w-[266px] translate-x-[-50%] left-[50%]"
          />
          <img src="/cards/3.png" alt="card" className="absolute bottom-0 left-0 right-0"/>
        </div>
      </div>

      <div className="max-w-[1244px] mx-auto">
        <p
          className="text-center text-darkGray font-bold text-[32px] leading-[39px] mb-12 lg:mb-5"
        >Начни зарабатывать сейчас</p>

        <div className="flex items-center gap-12 lg:flex-col lg:px-4">
          <div className="w-1/3 flex items-center lg:w-full">
            <p className="text-yellow text-[80px] font-bold tracking-tighter">01</p>
            <div className="ml-2">
              <p className="text-[20px] leading-[22px] mb-1 text-black whitespace-nowrap">Зарегистрируйся</p>
              <p className="text-[14px] leading-[16px] text-black/80">
                Заполни форму регистрации и получи доступ к личному кабинету
              </p>
            </div>
          </div>

          <div className="w-1/3 flex items-center lg:w-full">
            <p className="text-yellow text-[80px] font-bold tracking-tighter">02</p>
            <div className="ml-2">
              <p className="text-[20px] leading-[22px] mb-1 text-black whitespace-nowrap">Отправь заявку</p>
              <p className="text-[14px] leading-[16px] text-black/80">
                Достаточно ФИО, телефона и ИНН для формирования заявки
              </p>
            </div>
          </div>

          <div className="w-1/3 flex items-center lg:w-full">
            <p className="text-yellow text-[80px] font-bold tracking-tighter">03</p>
            <div className="ml-2">
              <p className="text-[20px] leading-[22px] mb-1 text-black whitespace-nowrap">Получи вознаграждение</p>
              <p className="text-[14px] leading-[16px] text-black/80">
                Вся информацию по заявкам и сумме выплат в удобном личном кабинете
              </p>
            </div>
          </div>
        </div>
      </div>

      <CountReward />

      <div className="mt-40 text-center lg:mt-10">
        <p className="font-bold text-black text-[32px] leading-[39px] mb-9">Вопросы и ответы</p>
        <div className="mb-10 w-[60%] mx-auto lg:w-full">
          {
            FAQ_DATA?.map(
              (item, index) =>
                <Collapse
                  key={index}
                  title={item.title}
                  description={item.description}
                  className={clsx(FAQ_DATA?.length - 1 !== index && "border-b border-solid border-borderBottom")}
                />
            )
          }
        </div>
      </div>

      <div className={
        clsx(
          "relative my-[160px] max-w-[1320px] w-full mx-auto bg-frame min-h-[338px] flex flex-col items-center justify-center bg-no-repeat lg:min-h-[250px] lg:px-4",
          "after:content-none lg:after:content-[''] after:absolute after:w-full after:h-full after:bg-mainBlack/40"
        )
      }>
        <p className="relative font-bold text-2xl leading-[29px] text-white mb-1 lg:mb-4 z-10">Остались вопросы?</p>
        <p className="relative text-sm leading-[16px] text-white mb-6 lg:text-center z-10">
          Укажите ваш телефон, мы перезвоним в течение 15 минут и ответим на них!
        </p>

        <Button title={'Написать'} className="relative z-10" onClick={handleOpenModal} type={BUTTON_TYPES.SECONDARY} />
      </div>

      <Footer />
    </>
  );
}

export default Landing;
